// extracted by mini-css-extract-plugin
export default {"body":"violationsDetailsModal_body__90j1N"};